module.exports = __webpack_public_path__ + "static/media/dw.5e132279.jpg";